const vueComponents = async () => {
    const postList = document.querySelector(".post-list");
    if ( !( postList ) ) return;

    const {
        createApp,
        defineAsyncComponent
    } = await import('vue');

    const $VueApp = createApp({});

    if (postList) {
        $VueApp.component("post-list", defineAsyncComponent({
            loader: () => import("./vue/post-list.vue"),
        }));
    }

    if (document.getElementById("app")) {
        $VueApp.mount('#app');
    }
}

export const init = vueComponents;